import React from 'react';
import { View, Text, StyleSheet, Button, ScrollView, Dimensions, Alert, Keyboard, Platform } from 'react-native';
import Colors from '../../../constants/Colors';
import CS from '../../../constants/Styles';
import { BackgroundGradient, Loader, SafeAreaView } from '../../../components';
import Carousel, { Pagination } from 'react-native-snap-carousel';
import ChangeItem from '../../../components/Carousel/Changes';
import * as rtApi from '../../../components/Api';
import { useLinkTo } from '@react-navigation/native';
import UserState from '../../../src/contexts/UserState';

const ProjectChanges = ({ navigation, route }) => {
  const [user, setUser] = React.useContext(UserState);
  let changes = [
    {
      id: [1],
      type: 'description',
      avatar: {
        id: 202,
        version: '9AsffN5tUJoSA18gNV0nkUyUvUJdBkol',
      },
      memo: 'Chad changed the description',
      old_value: 'Original Description',
      new_value: 'Updated Description',
    },
    {
      id: [2],
      type: 'image',
      avatar: {
        id: 202,
        version: '9AsffN5tUJoSA18gNV0nkUyUvUJdBkol',
      },
      path: 'https://dev.renovationtrust.com/api/v1/agreements/113/uploads/6',
      caption: 'Just a test Caption',
      memo: 'Chad added a photo',
    },
    {
      id: [3],
      type: 'location',
      avatar: {
        id: 202,
        version: '9AsffN5tUJoSA18gNV0nkUyUvUJdBkol',
      },
      memo: 'Chad wants to change the location of the project.',
      old_value: '200 Bay St, Toronto, ON M5J 2J2',
      new_value: '202 Bay St, Toronto, ON M5J 2J2',
    },
    {
      id: [4],
      type: 'milestone',
      avatar: {
        id: 202,
        version: '9AsffN5tUJoSA18gNV0nkUyUvUJdBkol',
      },
      memo: 'Chad added a milestone',
      old_value: [
        {
          title: 'Old Tiles Removed',
          description: 'Once all of the old tiles have been torn out and disposed of. Prior to new material being installed.',
          amount: '$1,200.00',
          direction: 'Fund',
        }
      ],
      new_value: [
        {
          title: 'Old Tiles Removed updated',
          description: 'Once all of the old tiles have been torn out and disposed of. Prior to new material being installed.',
          amount: '$1,200.00',
          direction: 'Fund',
        }
      ]
    },
    {
      id: [5],
      type: 'caption',
      avatar: {
        id: 202,
        version: '9AsffN5tUJoSA18gNV0nkUyUvUJdBkol',
      },
      memo: 'Peter Plum wants to change the caption.',
      old_value: 'Old Caption',
      new_value: 'Updated Caption',
      path: 'https://dev.renovationtrust.com/api/v1/agreements/113/uploads/6',
    }
  ];

  const [loading, setLoading] = React.useState(false);
  const [activeIndex, setActiveIndex] = React.useState(0);
  const [pendingChanges, setPendingChanges] = React.useState([]);
  // const [pendingChanges, setPendingChanges] = React.useState(changes); //testing
  const [completedChanges, setCompletedChanges] = React.useState(false);

  const firstTimeRender = React.useRef(true);
  const linkTo = useLinkTo();

  let carouselRef = React.useRef(null);
  const SLIDER_WIDTH = Dimensions.get('window').width - 20; // 20 is screen margin

  React.useEffect(() => {
    getProjectChanges(route.params.projectId);
    return rtApi.cancel();
  }, [route.params.projectId]);

  React.useEffect(() => {
    if (!firstTimeRender.current) {
      checkCompleted();
    }
  }, [pendingChanges]);

  React.useEffect(() => {
    firstTimeRender.current = false
  }, [])

  const getProjectChanges = (id) => {
    rtApi.get(`agreements/${id}`)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      console.log('getProjectChanges: ', data);
      processPendingChanges(data.agreement.pending_changes);
    });
  }

  const processPendingChanges = (changes) => {
    console.log('processPendingChanges: ', changes);
    const changeTypes = ['description', 'location', 'other', 'captions', 'milestones'];
    const imageTypes = ['other', 'inspiration', 'progress', 'captions']; // arrays
    let pendingChanges = [];
    let c = {};
    for(let type in changes){
      if(changeTypes.includes(type)){
        if (imageTypes.includes(type)) {
          changes[type].forEach(i => {
            c = { ...i };
            if(type === 'captions'){
              c.captionType = c.type;
              c.type = 'caption';
            }
            pendingChanges.push(c);
          })
        } else {
          c = { ...changes[type] };
          c.type = type;
          pendingChanges.push(c);
        }
      }
    }
    console.log('processPendingChanges', pendingChanges);
    setPendingChanges(pendingChanges);
  }

  const pagination = () => {
    if(Platform.OS === 'web'){ return null; }
    // const { entries, activeSlide } = this.state;
    return (
      <Pagination
        // dotsLength={changes.length}
        dotsLength={pendingChanges.length}
        activeDotIndex={activeIndex}
        containerStyle={{ paddingVertical: 10 }}
        dotStyle={{
          width: 10,
          height: 10,
          borderRadius: 5,
          marginHorizontal: 0,
          backgroundColor: Colors.yellow,
        }}
        inactiveDotStyle={{
          backgroundColor: Colors.lightGrey
        }}
        inactiveDotOpacity={0.4}
        inactiveDotScale={0.6}
      />
    );
  }

  const buildFormData = (item, decision) => {
    let fd = new FormData();
    if (Array.isArray(item.id)) {
      // potentially remove this as id isn;t supposed to be an array anymore
      // also remove array stuff in removeItem()
      fd.append('id', JSON.stringify(item.id));
    } else {
      fd.append('id', item.id);
    }
    fd.append('type', item.type);
    fd.append('decision', decision);
    return fd;
  }
  const buildFormDataChange = (item, newValue) => {
    let fd = new FormData();
    if(item.type === 'description'){
      fd.append('description', newValue);
    }else if(item.type === 'location'){
      fd.append('street_id', newValue.streetId);
      fd.append('address_number', newValue.streetNumber);
      if (newValue.addressUnit) {
        fd.append('address_unit', newValue.addressUnit);
      }
    }else if(item.type === 'caption'){
      fd.append('caption', newValue);
    }
    return fd;
  }
  const acceptChange = (item) => {
    console.log('acceptChange: ', item);
    const fd = buildFormData(item, 'Accepted');
    acceptReject(fd, item);
  }
  const removeItem = (item) => {
    console.log('acceptItem: ', item);
    setPendingChanges(prevState => {
      return prevState.filter(i => {
        // keep if type is diff or if ids dont match
        if(Array.isArray(item.id)){
          return (item.type !== i.type) ? true : (item.id[0] !== i.id[0]); 
        }else{
          return (item.type !== i.type) ? true : item.id !== i.id;
        }
      })
    });
  }
  const rejectChange = (item) => {
    console.log('rejectChange', item);
    const fd = buildFormData(item, 'Rejected');
    acceptReject(fd, item);
  }
  const makeChange = async (item, newValue) => {
    const fd = buildFormData(item, 'Rejected');
    const rejectResult = await acceptReject(fd, item);
    if(rejectResult.result){
      performChange(item, newValue);
    }
  }
  const performChange = (item, newValue) => {
    console.log('performChange()')
    setLoading(true);
    let fd = buildFormDataChange(item, newValue);
    let url = item.type === 'caption' ? `agreements/${route.params.projectId}/uploads/${item.agreement_upload_id}` : `agreements/${route.params.projectId}`;
    rtApi.put(url, fd)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      console.log('performChange data: ', data);
    })
    .finally(() => {
      setLoading(false);
    })
  }
  const acceptReject = (fd, item) => {
    return new Promise((resolve, reject) => {
      setLoading(true);
      rtApi.put(`agreements/${route.params.projectId}/decide`, fd)
      // rtApi.post(`agreements/${route.params.projectId}/${type}/${id}/${status}`)
      .then(data => {
        if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
        console.log('acceptReject success: ', data);
        if (data.result) {
          removeItem(item);
          resolve(data);
        }else{
          reject(data);
        }
      })
      .finally(() => {
        setLoading(false);
      });
    });
  }
  const checkCompleted = () => {
    console.log('checkCompleted()')
    const notCompleted = pendingChanges.filter(c => {
      return !c.completed;
    });
    console.log(notCompleted);
    setCompletedChanges(notCompleted.length === 0 ? true : false);
    if (notCompleted.length === 0){
      // navigation.navigate('Project', { projectId: route.params.projectId })
      linkTo(`/project/${route.params.projectId}?refresh=${Math.floor(Math.random() * 1000)}`);
    }else{
      // goToNext();
    }
  }

  return (
    <SafeAreaView style={CS.safe}>
      <BackgroundGradient />
      <Loader animating={loading} />
      <View style={CS.innerContainer}>
        <Carousel
          layout='default'
          ref={ref => carouselRef = ref}
          data={pendingChanges}
          // data={changes}
          sliderWidth={SLIDER_WIDTH}
          itemWidth={SLIDER_WIDTH}
          // renderItem={renderItem}
          renderItem={({ item }) => <ChangeItem item={item} acceptChange={acceptChange} rejectChange={rejectChange} makeChange={makeChange} projectId={route.params.projectId} />}
          onSnapToItem={index => setActiveIndex(index)}
          onBeforeSnapToItem={() => Keyboard.dismiss()}
          // useScrollView={true}
          enableMomentum={true}
          decelerationRate={0.9}
          // hasParallaxImages={true}
        />
        {/* </ScrollView> */}
        {pagination()}

      </View>
    </SafeAreaView>
  );

}

const styles = StyleSheet.create({
  
});

export default ProjectChanges;